import { render, staticRenderFns } from "./SidebarAction.vue?vue&type=template&id=9d9636f2&scoped=true"
import script from "./SidebarAction.vue?vue&type=script&lang=js"
export * from "./SidebarAction.vue?vue&type=script&lang=js"
import style0 from "./SidebarAction.vue?vue&type=style&index=0&id=9d9636f2&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d9636f2",
  null
  
)

export default component.exports